import type { BoxProps } from '../box/box';
import { Box } from '../box/box';
import { filterDisplayProps } from '../box/utils';

type LayoutProps = Partial<
  Pick<
    BoxProps,
    | 'alignContent'
    | 'children'
    | 'spacing'
    | 'stack'
    | 'padding'
    | 'expand'
    | 'className'
    | 'Component'
    | 'style'
    | 'id'
    | 'variant'
    | 'size'
    | 'constrain'
    | 'ref'
  >
>;

const INTERNAL_Layout = ({
  children,
  spacing,
  padding,
  expand,
  className,
  Component,
  style,
  id,
  size,
  constrain,
  alignContent,
  variant,
  stack,
  ref,
}: LayoutProps) => (
  <Box
    ref={ref}
    spacing={spacing}
    padding={padding}
    expand={expand}
    className={className}
    Component={Component}
    style={style}
    id={id}
    size={size}
    constrain={constrain}
    {...filterDisplayProps({ variant, alignContent, stack })}
  >
    {children}
  </Box>
);

export const Row = (props: Omit<LayoutProps, 'stack'>) => (
  <INTERNAL_Layout stack="row" {...props} />
);

export const Column = (props: Omit<LayoutProps, 'stack'>) => (
  <INTERNAL_Layout {...props} />
);
